import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@mui/material';
import PropTypes from 'prop-types';


function DialogAlert({ open, onClose,message }) {
  return (
    <Dialog open={open} 
    sx={{
        '& .MuiDialog-paper': {
          minWidth: '350px !important',
        
        },
      }}
    onClose={onClose}>
      <DialogTitle>ERROR</DialogTitle>
      <Divider sx={{marginY: 2}} />

      <DialogContent>
        <DialogContentText>
         {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
       
        <Button onClick={onClose} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
DialogAlert.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    message:PropTypes.string
  };

export default DialogAlert;
